import Podthumb1 from '../assets/podthumb1.jpeg';
import Podthumb2 from '../assets/podthumb2.jpeg';
import Podthumb3 from '../assets/Podthumb3.jpeg';
import Podthumb4 from '../assets/Podthumb4.jpeg';

const podcasts = [
  {
    title: 'Creating Impact Beyond Profit',
    thumbnail: Podthumb4,
    youtube: 'https://www.youtube.com/watch?v=iDE-S5CLTkA',
    date: '27th,June 2026',
    guest: 'Babatunde Akin Moses',
    guestRole: 'Founder & Social Impact Leader',
    description:
      'Discover how purpose-driven leadership can create meaningful impact beyond financial success. Join this powerful conversation featuring practical insights, leadership lessons, and real-life experiences.',
  },
  {
    title: 'Taking Chances: The Audacity to Turn Challenges Into Opportunities',
    thumbnail: Podthumb3,
    youtube: 'https://youtu.be/ZZ5ZbrbW6JY?si=g-K53Aisd6gUgYuY',
    date: '25th,May 2026',
  },

  {
    title:
      'Engineering, Excellence, and Evolving with Grace: Leading in Industry and the Home.',
    thumbnail: Podthumb2,
    youtube: 'https://youtu.be/yKRczvfaxZM?si=hVNsnTn-dFkECspW',
    date: '18th,March 2026',
  },
  {
    title:
      'Faith, Creativity & Cultural Influence:Becoming a Kingdom-Minded Creative in Today"s Media Landscape',
    thumbnail: Podthumb1,
    youtube: 'https://youtu.be/OgkiwkmdsZ8?si=MqV4Ho_edcGvIgYl',
    date: '27th,January 2026',
  },

  // {
  //   title: 'Leadership & Personal Growth',
  //   thumbnail: '/podcasts/podcast3.jpg',
  //   youtube: 'https://www.youtube.com/watch?v=xxxxx',
  //   date: 'Mar 2026',
  // },
];

export default podcasts;
